module.exports = __webpack_public_path__ + "img/account_add.5a4c77d3.svg";